import "core-js";
import { createApp } from "vue";
import App from "./app/App.vue";
import router from "@/router/Router";
import Maska from "maska";
import { store } from "@/store/Store";
import { createPinia } from "pinia";
import '@vuepic/vue-datepicker/dist/main.css';
import { Tooltip } from "floating-vue";
import "floating-vue/dist/style.css";
import "@/assets/tailwind.css";
import '@/assets/main.css'

const app = createApp(App);
const pinia = createPinia();

app.component("base-tooltip", Tooltip);

app
  .use(store)
  .use(pinia)
  .use(router)
  .use(Maska)
  .mount("#app");
